module.exports = __webpack_public_path__ + "static/img/active6.729e2ac4.png";